<template>
  <v-sheet  border class="d-flex flex-column align-start ma-2 pa-3 rounded-lg bg-card"  max-width="500">
    <label class="text-start text-h6" >{{ title }}</label>
    <label class="text-start">{{ content }}</label>
  </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import { defineComponent } from 'vue';
export default defineComponent( {
  props: {
    title: String,
    content: String,
  },
  components: {},
  computed: {
    ...mapState({ $_darkMode: "darkMode" }),
  },
});
</script>
